import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-apttus3',
  template: `
    <p>
      apttus3 works!
    </p>
  `,
  styles: []
})
export class Apttus3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
